'use client';

import Zzimlogo5024 from '@svg/main/zzimlogo_50_24.svg';
import Hamburger3232 from '@svg/main/hamburger_32_32.svg';
import Link from 'next/link';
import { useSetAtom } from 'jotai';
import { sideMenuModalAtom } from '@/atom/modal';
import { historyStackAtom } from '@/atom/historyStack';
import { usePathname } from 'next/navigation';
import { history } from '@/utils/history';

export default function MainTopBar() {
  const pathname = usePathname();

  const setSideMenuModal = useSetAtom(sideMenuModalAtom);
  const setHistoryStack = useSetAtom(historyStackAtom);

  const onClickSideMenu = () => {
    history?.push(pathname);
    setHistoryStack((prev) => [
      ...prev,
      {
        name: '사이드메뉴 닫기 (from main-top-bar.tsx)',
        afterAction: () => {
          setSideMenuModal(false);
        },
      },
    ]);
    setSideMenuModal(true);
  };

  return (
    <div
      id='main-top-bar'
      className='max-w-480pxr fixed top-0 z-20 flex items-center justify-between w-full overflow-hidden bg-white h-56pxr py-16pxr px-20pxr'
    >
      <Link href={process.env.NEXT_PUBLIC_ZZIMCAR_URL ?? ''} prefetch={false}>
        <img src='https://front-cdn.zzimcar.com/images/zzim_logo_mo.svg' alt='zzim-logo' />
      </Link>
      <button onClick={onClickSideMenu} className='w-24pxr h-24pxr flex items-center justify-center'>
        <img src='https://front-cdn.zzimcar.com/images/menu_hamburger.svg' alt='menu' />
      </button>
    </div>
  );
}
